/**
 * Idempotency client_action_id generator.
 *
 * Mỗi request POST thay đổi state cần `client_action_id` UUIDv4 (INV-I02).
 * Frontend gen mới mỗi request "real"; retry KHÔNG gen lại.
 */

export function newActionId(): string {
  // crypto.randomUUID gen UUIDv4 chuẩn (Node 19+, modern browsers).
  return crypto.randomUUID();
}
